import { useTranslation } from 'react-i18next';
import './contract-info-card.component.scss';
import { Contract, ContractsTable } from './contracts-table.component';
import { useState } from 'react';

const blobURL = import.meta.env.VITE_API_IMAGE_URL

const workAgrementSwedish = `${blobURL}/Allmänt avtal för Egenanställning.pdf`;
const workAgrementEnglish = `${blobURL}/General Contract for Self-Employment.pdf`;
const AgreementSwedish = `${blobURL}/AgrementSwedish.pdf`;
const EnglishAgreement = `${blobURL}/EnglishAgrement.pdf`;

export const ContractInfoCard = () => {
  const { t } = useTranslation();
  const language = new URLSearchParams(window.location.search).get('lang') || 'en';

  function handleClick() {
    if (language === 'sv-se') {
      window.open(AgreementSwedish)
    }
    else {
      window.open(EnglishAgreement)
    }
  }

  const [contracts] = useState<Contract[]>([
    {
      id: '1',
      document: 'GENERAL_DOCUMENT',
      duration: '12/05/2023 - 11/09/2024',
      fileUrl: language == 'sv-se' ?   workAgrementSwedish : workAgrementEnglish,
    },
  ]); 

  return (
    <div className="contract-info-card">
      <div className="contract-info-card__header">
        <div className="contract-info-card__header-content">
          <h3 className="contract-info-card__title">
            {t('CONTRACT_WITH_INVOZIO')}
          </h3>
        </div>
        <div className="contract-info-card__header-actions">
          <button className="contract-info-card__employment-btn" onClick={() => handleClick()}>
            {t('EMPLOYMENT_CONTRACT')}
          </button>
        </div>
      </div>
      <div className="contract-info-card__body">
        <p className="contract-info-card__description">
          {t('CONTRACT_DESCRIPTION')}
        </p>
        <ContractsTable contracts={contracts} />
      </div>
    </div>
  );
};
